import { Component, OnInit, ChangeDetectorRef, Inject } from "@angular/core";

import { ApiService } from "src/app/core/services/shared/api.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { CodehelpService } from "virtue-form";
import { TuiDialogContext } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";

export class counselor {
  public appliedCouponCode: string;
}
@Component({
  selector: "app-pay-subscribe",
  templateUrl: "./pay-subscribe.component.html",
  styleUrls: ["./pay-subscribe.component.scss"],
})
export class PaySubscribeComponent implements OnInit {
  model = new counselor();
  isApplyCouponCode: boolean = false;
  showLoader: boolean = false;
  validateCouponCode: string;
  priceId: string = "";
  selectedPrice: string = "";
  PriceList: any[] = [];
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<string>,
    public apiService: ApiService,
    private notificatioService: NotificationService,
    public globalvar: GlobalVarService,
    private codehelp: CodehelpService
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("pay-subscribe");
  }

  ngOnInit(): void {
    if (this.globalvar.PriceList.length > 0) {
      this.PriceList = this.globalvar.PriceList;
      this.priceId = this.PriceList[0].priceStripeId;
      this.selectedPrice = this.PriceList[0].priceStripeId;
      console.log(this.PriceList, "pricelist");
    }
    const profile = JSON.parse(this.codehelp.getUserProfile() || "{}");
    console.log(profile);
  }
  applyCoupon() {
    this.isApplyCouponCode = !this.isApplyCouponCode;
  }

  close() {
    this.context.completeWith("");
    // const dialog = document.querySelector('tui-dialog');
    // dialog.classList.remove('payment');
  }
  apiCalled: boolean = false;
  AllData(priceid: any) {
    this.selectedPrice = priceid;
    this.priceId = priceid;
  }
  onRadioChange(data: any) {
    this.priceId = data.priceStripeId;
    this.selectedPrice = data.priceStripeId;
  }
  getPriceLabel(label: string) {
    if (label == "month") {
      return "Monthly";
    }
    if (label == "year") {
      return "Annual";
    }
  }
  submit() {
    // this.showLoader = true;
    this.apiService
      .PaymentFromTool(this.globalvar.ProductKey, this.priceId)
      .then(
        (resp: any) => {
          if (resp) {
            // this.showLoader = false;
            if (resp.created == true) {
              if (resp?.linkUrl && resp?.errorMsg == null) {
                // this.showLoader = false;
                window.open(resp?.linkUrl, "_blank");
              }
            }
          }
        },
        (error) => {
          if (error.status == "500" || error.status) {
            this.notificatioService.showNotification(
              "Please enter valid coupon code.",
              "Invalid coupon code",
              true,
              "warning"
            );
          }
        }
      );

    // this.otp = true;
    // if (this.isDisabledCouponCode == true) {
    //   data.value.coupon = this.model.coupon;
    // }
  }
  handlecoupon(arg) {
    if (arg.target.value == "") {
      this.validateCouponCode = "Coupon code is required";
    }
    if (arg.target.value) {
      this.validateCouponCode = "";
    }
  }
}
